"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = (0, makeStyles_1.default)(() => ({
    root: {
        height: 22,
        verticalAlign: 'top',
        display: 'flex',
        width: '100%',
        maxWidth: 150,
        '&:before': {
            border: 0,
        },
        // selected color
        '& > div > button': {
            width: 150,
            height: 18,
            borderRadius: 0,
            marginBottom: '2pt',
            // necessary to override default hover color (because its confusing)
            '&:hover': {
                backgroundColor: 'var(--picker-hover-color) !important',
                opacity: 'var(--picker-hover-opacity)',
                '& > span > div': {
                    backgroundColor: 'var(--picker-hover-color) !important',
                    opacity: 'var(--picker-hover-opacity)',
                },
            },
        },
        // second box with selected color
        '& > div > button > span > div': {
            width: 150,
            height: 20,
            borderRadius: 0,
        },
    },
    icon: {
        padding: 1,
        marginRight: '2pt',
    },
    input: {
        padding: '2pt',
    },
    disabled: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
}));
//# sourceMappingURL=color-picker-styles.js.map